import classNames from 'classnames';
import { TextArea } from 'components/shared/TextField/TextArea';
import { FC } from 'react';

type OwnProps = {
  value: string;
  className?: string;
  disabled?: boolean;
  onChange: (newComment: string) => void;
};
export const Comment: FC<OwnProps> = ({ value, className, disabled, onChange }) => (
  <TextArea
    className={classNames('form-control', className)}
    e2e="fightback-comment"
    value={value}
    disabled={disabled}
    onValueChanged={onChange}
    placeholder="Please input a comment"
  />
);
